import {StockOperationType} from "../api";

const stockOperationTypeTranslations: { type: StockOperationType, translation: string }[] = [
    {type: StockOperationType.Pz, translation: "Przyjęcie zewnętrzne"},
    {type: StockOperationType.Wz, translation: "Wydanie zewnętrzne"},
    {type: StockOperationType.Mm, translation: "Międzymagazynowe"},
    {type: StockOperationType.Vn, translation: "Produkcja"},
    {type: StockOperationType.Oi, translation: "Inwentaryzacja"},
    {type: StockOperationType.Pw, translation: "Przyjęcie wewnętrzne"},
    {type: StockOperationType.Rw, translation: "Wydanie wewnętrzne"},
    {type: StockOperationType.Opp, translation: "Operacja produkcyjna"},
    {type: StockOperationType.Opw, translation: "Produkcja zużycie"},
]

const stockOperationTypeTranslationHelper = (type: StockOperationType) =>
    stockOperationTypeTranslations.find(x => x.type === type)?.translation ?? "";

export default stockOperationTypeTranslationHelper;